var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 17.5,
    height: 17.5,
    rx: 2,
    fill: "#0D0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 17.5C14.7018 17.5 17.5 14.7018 17.5 11.25C17.5 7.79822 14.7018 5 11.25 5C7.79822 5 5 7.79822 5 11.25C5 12.3709 5.29509 13.4229 5.81182 14.3326L5 17.5L8.26556 16.7428C9.1524 17.2256 10.1692 17.5 11.25 17.5ZM11.25 16.5385C14.1707 16.5385 16.5384 14.1707 16.5384 11.25C16.5384 8.32927 14.1707 5.96154 11.25 5.96154C8.32926 5.96154 5.96154 8.32927 5.96154 11.25C5.96154 12.3777 6.31451 13.423 6.916 14.2814L6.44231 16.0577L8.24997 15.6058C9.10239 16.194 10.136 16.5385 11.25 16.5385Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68751 8.34812C9.53891 8.04965 9.31095 8.07607 9.08066 8.07607C8.66909 8.07607 8.02734 8.56905 8.02734 9.48655C8.02734 10.2385 8.35869 11.0616 9.47519 12.2929C10.5527 13.4811 11.9685 14.0959 13.1439 14.0749C14.3192 14.054 14.561 13.0426 14.561 12.701C14.561 12.5496 14.4671 12.4741 14.4024 12.4536C14.0018 12.2613 13.2631 11.9031 13.095 11.8359C12.9269 11.7686 12.8391 11.8596 12.7846 11.9091C12.6321 12.0544 12.33 12.4824 12.2266 12.5787C12.1231 12.675 11.9689 12.6263 11.9047 12.5899C11.6685 12.4951 11.0281 12.2103 10.5176 11.7154C9.88631 11.1034 9.84926 10.8929 9.73032 10.7054C9.63516 10.5555 9.70499 10.4635 9.73983 10.4233C9.87585 10.2664 10.0637 10.0241 10.1479 9.90365C10.2321 9.78323 10.1653 9.60041 10.1251 9.48655C9.95258 8.99684 9.80639 8.5869 9.68751 8.34812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappBlack);
export default __webpack_public_path__ + "static/media/whatsapp-black.fee288d90665d4dca0c2c20fb100495a.svg";
export { ForwardRef as ReactComponent };